import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, interval, switchMap, map } from 'rxjs';
import { Lesson } from 'app/models/lessons.model';
import { QuizConfig, TocTree } from 'app/models/toc.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';
import { uploadAssetUrl } from '../utils/upload-asset-url';
import { postSse, type SseEvent } from '../utils/sse-post';

@Injectable({
  providedIn: 'root'
})
export class TOCService {


  private baseUrl = `${environment.baseUrl}/lessonMgmt`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }



  getTOC(userid: number, lessonId: number): Observable<any> {
    // debugger;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "tenant": null
      }
    };

    // let aaa = this.http.post(`${this.baseUrl}/getTOC`, body, { headers });
    // console.log('getTOC response:', aaa);

    return this.commonAPI.postApiCall(`${this.baseUrl}/getTOC`, body);
    // return aaa;
    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }


  saveTOC(userid: number, lessonId: number, toc: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "toc": toc,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/saveTOC`, body);

    // return this.http.post(`${this.baseUrl}/saveTOC`, body, { headers });
  }

  generatePPT(userid: number, lessonId: number,) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "lessontype": "REVIEW",
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/generatePPT`, body);

    // return this.http.post(`${this.baseUrl}/generatePPT`, body, { headers });
  }

  translateAndGenerate(userid: number, lessonId: number, language: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,
        "languageTo": language,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/translateAndGenerate`, body);

    // return this.http.post(`${this.baseUrl}/translateAndGenerate`, body, { headers });
  }

  uploadBackgroundFromDataUrl(
    userid: number,
    lessonId: number,
    fileName: string,
    fileBase64: string
  ): Observable<{ fileName: string; relativePath?: string }> {
    const body = {
      criteria: {
        userId: userid,
        lessonId,
        fileName,
        fileBase64,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/uploadBackground`, body);
  }



  deleteBackground(lessonId: number, userid: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userid,
        "lessonId": lessonId,

        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/deleteBackground`, body);

    // return this.http.post(`${this.baseUrl}/deleteBackground`, body, { headers });

  }


  getBackgroundUrl(fileName: string, userId: number, lessonId: number) {
    const safe = String(fileName || '').replace(/^[/\\]+/, '');
    if (!safe) return '';
    const rel = `lessons/u${userId}_l${lessonId}/backgrounds/${safe}`;
    return uploadAssetUrl(rel);
  }






  generateTOC(
    userid: number,
    lessonId: number,
    quizConfig?: QuizConfig | null,
    linkedProjectAction?: 'clear' | 'unlink' | null,
  ) {
    const body: { criteria: Record<string, unknown> } = {
      criteria: {
        userId: userid,
        lessonId: lessonId,
        tenant: null,
      },
    };
    if (quizConfig != null) {
      body.criteria['quizConfig'] = quizConfig;
    }
    if (linkedProjectAction === 'clear' || linkedProjectAction === 'unlink') {
      body.criteria['linkedProjectAction'] = linkedProjectAction;
    }

    return this.commonAPI.postApiCall(`${this.baseUrl}/generateTOC`, body);

    // return this.http.post(`${this.baseUrl}/generateTOC`, body, { headers });
  }


  /**
   * SSE: progress while TOC is loaded or AI-generated (same shape as getTOC `Data`).
   */
  streamGetTOC(
    userid: number,
    lessonId: number,
    onEvent: (ev: SseEvent) => void,
    options?: {
      autoGenerate?: boolean;
      quizConfig?: QuizConfig | null;
      timeoutMs?: number;
    },
  ): Promise<void> {
    const criteria: Record<string, unknown> = {
      userId: userid,
      userID: userid,
      lessonId,
    };
    if (options?.autoGenerate === true) {
      criteria['autoGenerate'] = true;
    }
    if (options?.quizConfig != null) {
      criteria['quizConfig'] = options.quizConfig;
    }
    return postSse('/lessonMgmt/streamGetTOC', criteria, onEvent, {
      timeoutMs: options?.timeoutMs ?? 600_000,
    });
  }

  clearLessonContent(userid: number, lessonId: number): Observable<unknown> {
    const body = {
      criteria: {
        userId: userid,
        lessonId: lessonId,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/clearLessonContent`, body);
  }

  eraseAndGenerate(userid: number, lessonId: number, quizConfig?: QuizConfig | null, linkedProjectAction?: 'clear' | 'unlink' | null) {
    const body: { criteria: Record<string, unknown> } = {
      criteria: {
        userId: userid,
        lessonId: lessonId,
        tenant: null,
      },
    };
    if (quizConfig != null) {
      body.criteria['quizConfig'] = quizConfig;
    }
    if (linkedProjectAction === 'clear' || linkedProjectAction === 'unlink') {
      body.criteria['linkedProjectAction'] = linkedProjectAction;
    }

    return this.commonAPI.postApiCall(`${this.baseUrl}/eraseandGenerateTOC`, body);

    // return this.http.post(`${this.baseUrl}/eraseAndGenerateTOC`, body, { headers });
  }


}

